// Photo upload against the photod sidecar, reached through the same-origin
// /photos proxy (src/server.ts). Upload is authenticated (member JWT, same as
// GraphQL); reads are public per-key. photod sniffs the bytes and only accepts
// jpeg/png/webp up to 15MB.
import { authFetch } from "./auth";

/** URL an <img> can load the original stored photo from, via the same-origin proxy. */
export function photoUrl(storageKey: string): string {
  return `/photos/${storageKey}`;
}

/**
 * URL of a width x height smart-cropped rendition, rendered by imagor behind
 * the same-origin /img proxy. Mirrors the API's image_url() SQL helper — keep
 * the path shape in sync if either changes.
 */
export function thumbUrl(storageKey: string, width: number, height: number): string {
  return `/img/unsafe/${width}x${height}/smart/${storageKey}`;
}

/** Upload one image file; resolves to the storage key for the outing_photo row. */
export async function uploadPhoto(file: File): Promise<string> {
  const form = new FormData();
  form.append("file", file);
  const res = await authFetch("/photos", { method: "POST", body: form });
  const json = (await res.json().catch(() => ({}))) as Record<string, unknown>;
  if (!res.ok) {
    throw new Error(typeof json.error === "string" ? json.error : `photo upload failed (${res.status})`);
  }
  if (typeof json.storage_key !== "string") throw new Error("photo upload returned no storage key");
  return json.storage_key;
}
